module.exports = __webpack_public_path__ + "static/committed.ab94cdc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/committed.svg
// module id = 490
// module chunks = 35783957827783